import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import {
    BaseMultiInputStreamTransformation,
    BroadcastType
} from '../../../dataflow/base-multi-input-stream-transformation';
import { FLOW } from '../IDataflow';
import { Metamodel } from 'app/model/base/model';

export abstract class BaseMultiInputStreamTransformationAdapter extends TransformationAdapter<BaseMultiInputStreamTransformation> {
    public async getDslScript(transformation: BaseMultiInputStreamTransformation): Promise<string> {
        const expressionsScript = this.getExpressionScript(transformation);
        const partition = TransformationAdapter.getPartitionDslScript(transformation);
        const hint: string = this._getHint(transformation);
        const knownProps = [expressionsScript, partition, hint].filter((c) => !!c).join(',\n\t');
        const unknownProps = this._getUnknownProps(transformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(transformation)} ${this.getTransformationName(transformation)}(` +
            `${transformationData})` +
            `${FLOW} ${this._getOutputStreams(transformation)}`
        );
    }

    protected getTransformationName(transformation: BaseMultiInputStreamTransformation): string {
        return Metamodel.modelOf(transformation).name;
    }

    protected getExpressionScript(transformation: BaseMultiInputStreamTransformation): string {
        return DataFlowExpressionUtils.getConditionalExpressionScript(transformation.conditionExpressions);
    }

    private _getHint(transformation: BaseMultiInputStreamTransformation): string {
        let broadcastOption = 'auto';
        if (transformation.broadcastType !== BroadcastType.FIXED) {
            broadcastOption = transformation.broadcastType;
        } else {
            if (transformation.broadcastLeftStream && transformation.broadcastRightStream) {
                broadcastOption = 'both';
            } else if (transformation.broadcastLeftStream) {
                broadcastOption = 'left';
            } else if (transformation.broadcastRightStream) {
                broadcastOption = 'right';
            }
        }

        return `broadcast: '${broadcastOption}'`;
    }
}
